const dividerStyles = {
  mb: 1.25,
};

export const DividerStyles = dividerStyles;

const iconStyles = {
  fontSize: {
    xs: "3.85rem",
    sm: "3.9rem",
    md: "3.95rem",
    lg: "4rem",
  },
};

export const Iconstyles = iconStyles;

const cardStyles = {
  marginTop: {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
  },
  marginLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  marginRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingLeft: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  paddingRight: {
    xs: 1.75,
    sm: 2,
    md: 2.25,
    lg: 2.5,
  },
  width: {
    xs: "80%",
    sm: "85%",
    md: "90%",
    lg: "95%",
  },
};

export const CardStyles = cardStyles;

const linkStyles = {
  underline: "hover",
  align: "left",
  width: 1,
  fontSize: "24px",
};

export const LinkStyles = linkStyles;

const locationStyles = {
  textAlign: "right",
  width: 1,
  fontSize: "22px",
};

export const LocationStyles = locationStyles;

const timeframeStytles = {
  textAlign: "right",
  width: 1,
  fontSize: "16px",
};

export const TimeframeStyles = timeframeStytles;

const degreeStyles = {
  align: "left",
  width: 1,
  fontSize: "20px",
};

export const DegreeStyles = degreeStyles;
